import { LocalDate, DateTimeFormatter } from "@js-joda/core";

import {
    declareAiCapability,
    provideAiCapability,
} from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";

// Patient alerts describing its own date range. The page opens on the last month, which is why a
// request that names no dates leaves the range alone rather than widening it to everything.
declareAiCapability({
    id: "patientAlerts.filter",
    title: "Filter the patient alerts list",
    effect: "prefill",
    description:
        "Sets the date range on Patients > Patient Alerts and re-runs its search. The page opens on the last month; a range given here replaces it. Only works while that page is open.",
    location: "the date range of the Patients > Patient Alerts page",
    scope: "page",
    permissionKey: "view_patients_section_alerts",
    params: [
        { name: "from", type: "date", required: false, description: "First day to include, as yyyy-MM-dd." },
        { name: "to", type: "date", required: false, description: "Last day to include, as yyyy-MM-dd." }
    ],
    examples: [
        "patient alerts from last week",
        "patient alerts since january"
    ]
});

//! @ngInject
export function patientAlertsCtrl($scope, $rootScope, NgTableParams, DatabaseApi, toaster, FilterUtils, itemSearchPageManager) {
    $scope.tableParams = null;
    $scope.patientAlerts = [];

    $scope.preOpenPatientModal = function (patientId) {
        if (!patientId) return;
        $rootScope.openPatientModal(patientId);
    }

    $scope.preOpenCaregiverModal = function (caregiverId) {
        if (!caregiverId) return;
        $rootScope.openCaregiverModal(caregiverId);
    }

    var initialize = function () {
        initPageManager();
        $scope.pageManager.resetSearchParamsByUrl();

        // Load filters
        const storageFilters = FilterUtils.rootFilters.patientAlertsCtrl;
        if (storageFilters !== undefined) {
            $scope.pageManager.setSearchParams(storageFilters);
        }

        $scope.searchPatientAlerts();
    }

    $scope.$on("$destroy", function() {
        const filters = $scope.pageManager.searchParams;
        FilterUtils.rootFilters.patientAlertsCtrl = angular.copy(filters);
    });

    var initPageManager = function () {
        $scope.pageManager = itemSearchPageManager.createSearchPageManager("/patient_alerts");
        $scope.validatorsDataManager = $scope.pageManager.getValidatorsDataManager();
        $scope.pageManager.initFromToDateParams();
        $scope.pageManager.initValidatorsParam();
        $scope.pageManager.updateSearchParamValue("from", new Date(LocalDate.now().minusMonths(1).format(DateTimeFormatter.ofPattern("MM/dd/yyyy"))));
        $scope.pageManager.updateSearchParamValue("to", new Date(LocalDate.now().plusDays(1).format(DateTimeFormatter.ofPattern("MM/dd/yyyy"))));
    }

    var initTable = function (items) {
        var options = {
            count: 25
        };
        $scope.tableParams = new NgTableParams(options, {
            counts: [10, 25, 50, 100],
            dataset: items
        });
    };

    $scope.searchPatientAlerts = function () {
        $scope.pageManager.executeSearch().then(function (response) {
            $scope.patientAlerts = response.data.patientAlerts;
            initTable($scope.patientAlerts);
        }, function (error) {
            toaster.pop("error", "Failed to load patient alerts");
        });
    }

    $scope.$on('PatientAlertsUpdated', function () {
        $scope.searchPatientAlerts();
    });


    const releasePatientAlertsFilter = provideAiCapability("patientAlerts.filter", (args) => {
        const asDate = (text) => {
            const parts = String(text).split("-").map(Number);

            if (parts.length !== 3 || parts.some(isNaN)) {
                throw new Error("Could not read the date " + text + ".");
            }

            return new Date(parts[0], parts[1] - 1, parts[2]);
        };

        if (args.from !== undefined) {
            $scope.pageManager.searchParams.from.value = asDate(args.from);
        }

        if (args.to !== undefined) {
            $scope.pageManager.searchParams.to.value = asDate(args.to);
        }

        $scope.searchPatientAlerts();

        const range = [args.from, args.to].filter(Boolean).join(" to ");

        return range === "" ? "Re-ran the patient alerts search" : "Showing patient alerts " + range;
    });

    $scope.$on("$destroy", releasePatientAlertsFilter);

    initialize();
};